<template>
  <div :class="[!isSidebarToggle ? 'toggalclass' : '']">
    <loader :is-visible="$root.loading"></loader>
    <!-- <router-view /> -->
    <template
      v-if="
        $route.name !== 'homeNew' &&
        $route.name !== 'createaccount' &&
        $route.name !== 'activate' &&
        $route.name !== 'HomeIndia' &&
        $route.name !== 'createaccountIndia' &&
        $route.name !== 'activateIndia'
      "
    >
      <div class="mainHeaderWrap">
        <HeaderNew @toggleSidebar="toggleSidebar"></HeaderNew>
      </div>
      <div class="">
        <div class="">
          <Sidenav :isSidebarToggle="isSidebarToggle"></Sidenav>
        </div>
        <div class="mainContainerWrap">
          <router-view />
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import Vue from "vue";
import excel from "vue-excel-export";
import HeaderNew from "./components/layout/HeaderNew";
import Sidenav from "./components/layout/Sidenav";

// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import "../node_modules/font-awesome/less/font-awesome.less";

Vue.use(excel);
// Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)
export default {
  components: {
    HeaderNew,
    Sidenav,
  },
  data() {
    return {
      isSidebarToggle: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarToggle = !this.isSidebarToggle;
    },
  },
  mounted() {
    // console.log(this.$route)
  },
};
</script>
<style lang="scss">
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
}
.mainHeaderWrap {
  // padding-left: 65px;
  position: fixed;
  top: 0;
  width: 100%;
  height: 70px;
  z-index: 9;
  background-color: #f2f2f2;
}
.mainContainerWrap {
  margin-left: 65px;
  margin-top: 70px;
  transition: all 0.5s;
}
/*toggle class sidebar css*/
.toggalclass .mainHeaderWrap {
  //padding-left: 250px;
}
.toggalclass .mainContainerWrap {
  margin-left: 250px;
}
.toggalclass .navbar-vertical.navbar-expand-lg {
  width: 250px;
}
</style>
